export const categoriesMenuStyles = {
  // ===== Desktop trigger (pill button) =====
  desktopWrap: 'relative hidden min-[1274px]:inline-flex',
  trigger:
    'group relative inline-flex h-10 items-center gap-2 rounded-full px-4 text-sm font-semibold ' +
    'bg-bg-subtle text-fg-primary border border-border-subtle ' +
    'hover:border-accent hover:text-accent ' +
    'data-[open=true]:bg-accent data-[open=true]:text-accent-fg data-[open=true]:border-accent ' +
    'transition-colors duration-fast ease-token ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
  triggerIcon: 'h-4 w-4',
  triggerChevron:
    'h-4 w-4 transition-transform duration-fast ease-token data-[open=true]:rotate-180',

  // ===== Mobile trigger =====
  mobileTrigger:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors duration-fast ease-token min-[1274px]:hidden',
  mobileTriggerIcon: 'h-5 w-5',

  // ===== Desktop popover =====
  panelScrim:
    'animate-overlay-in fixed inset-x-0 top-16 bottom-0 z-overlay hidden min-[1274px]:block bg-black/40 backdrop-blur-[2px]',
  panel:
    'animate-panel-drop-in fixed inset-x-0 top-16 z-overlay hidden min-[1274px]:block ' +
    'bg-bg-canvas border-b border-border-subtle ' +
    'shadow-[0_24px_60px_-15px_rgba(0,0,0,0.35),0_8px_18px_-8px_rgba(0,0,0,0.25)] ' +
    'ring-1 ring-black/5',
  // The third column appears only while menu banners are published.
  panelInner:
    'mx-auto grid w-full max-w-[1400px] gap-6 px-6 py-6 lg:py-7 ' +
    'grid-cols-[260px_minmax(0,1fr)]',
  panelInnerWithPromo: 'min-[1274px]:grid-cols-[260px_minmax(0,1fr)_280px]',

  // ===== Header (shared) =====
  colHeader: 'text-fg-muted text-[10px] font-bold uppercase tracking-[0.18em] mb-3 px-2',
  emptyCol: 'text-fg-muted px-2 py-6 text-sm',

  // ===== Rail (root categories) =====
  rail: 'min-w-0 border-border-subtle bg-bg-subtle/40 rounded-xl p-2 flex flex-col',
  railList: 'flex flex-col gap-0.5 max-h-[460px] overflow-y-auto scrollbar-none pr-1',
  rootRow:
    'group relative flex items-center gap-3 rounded-lg px-2.5 py-2 text-left ' +
    'text-fg-primary font-medium ' +
    'transition-colors duration-fast ease-token ' +
    'hover:bg-bg-canvas hover:text-accent ' +
    'data-[active=true]:bg-bg-canvas data-[active=true]:text-accent data-[active=true]:shadow-sm ' +
    'focus-visible:outline-none focus-visible:bg-bg-canvas',
  rootThumb:
    'bg-bg-canvas border-border-subtle text-fg-secondary relative flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-md border',
  rootThumbImg: 'h-full w-full object-cover',
  rootLabel: 'min-w-0 flex-1 text-sm truncate',
  rootBadge: 'text-fg-muted ml-2 shrink-0 text-[11px] tabular-nums',

  // ===== Tiles (subcategories) =====
  tilesWrap: 'min-w-0 flex flex-col',
  tilesHeader: 'mb-4 flex items-end justify-between gap-3 px-1',
  tilesTitle: 'text-fg-primary text-lg font-semibold tracking-tight',
  tilesViewAll:
    'text-accent inline-flex items-center gap-1 text-xs font-semibold hover:underline focus-visible:outline-none focus-visible:underline',
  // 2 rows × 3-4 cols depending on width, scrollable if overflow.
  tilesGrid:
    'grid auto-rows-min gap-3 overflow-y-auto pr-1 max-h-[460px] scrollbar-none ' +
    'grid-cols-2 md:grid-cols-3 xl:grid-cols-3',
  tile:
    'group flex items-center gap-3 rounded-xl border border-border-subtle bg-bg-canvas p-3 ' +
    'transition-all duration-fast ease-token ' +
    'hover:-translate-y-0.5 hover:border-accent hover:shadow-md ' +
    'focus-visible:outline-none focus-visible:border-accent focus-visible:shadow-md',
  tileThumb:
    'bg-bg-subtle border-border-subtle text-fg-secondary relative flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-lg border ' +
    'group-hover:bg-accent group-hover:text-accent-fg group-hover:border-accent ' +
    'transition-colors duration-fast ease-token',
  tileBody: 'min-w-0 flex flex-col leading-tight',
  tileLabel: 'text-fg-primary truncate text-sm font-semibold group-hover:text-accent',
  tileCount: 'text-fg-muted text-[11px]',

  // ===== Categories-menu banners =====
  featuredList: 'hidden min-[1274px]:flex min-w-0 flex-col gap-3',
  featured:
    'relative flex min-w-0 flex-col gap-2 overflow-hidden rounded-xl border border-zinc-900/15',
  desktopFeatured: 'h-[205px] p-4',
  mobileFeatured:
    'h-[148px] w-[calc(100%-1.5rem)] max-w-[360px] shrink-0 snap-start p-3 only:w-full only:max-w-none',
  featuredEyebrow:
    'inline-flex w-fit items-center rounded-full bg-zinc-900 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em]',
  featuredEyebrowDark:
    'inline-flex w-fit items-center rounded-full bg-white px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-900',
  featuredTitle: 'text-zinc-900 text-base font-semibold leading-snug',
  featuredTitleDark: 'text-white text-base font-semibold leading-snug',
  featuredTitleClamp: 'line-clamp-2',
  featuredText: 'text-zinc-800 text-xs leading-relaxed',
  featuredTextDark: 'text-white text-xs leading-relaxed',
  featuredTextClamp: 'line-clamp-2',
  featuredCta:
    'mt-auto inline-flex w-fit max-w-full items-center gap-1.5 rounded-full bg-zinc-900 text-white px-3.5 py-1.5 text-xs font-semibold shadow-sm transition-transform duration-fast ease-token hover:scale-[1.02] hover:bg-zinc-800',
  featuredCtaDark:
    'mt-auto inline-flex w-fit max-w-full items-center gap-1.5 rounded-full bg-white text-zinc-900 px-3.5 py-1.5 text-xs font-semibold shadow-sm transition-transform duration-fast ease-token hover:scale-[1.02] hover:bg-zinc-100',

  // ===== Mobile drawer =====
  drawerScrim:
    'animate-overlay-in fixed inset-0 z-modal bg-black/60 backdrop-blur-sm min-[1274px]:hidden',
  drawer:
    'animate-drawer-in fixed inset-y-0 left-0 z-modal flex h-dvh w-full max-w-[432px] flex-col bg-bg-canvas shadow-2xl min-[1274px]:hidden',
  drawerHeader:
    'border-border-subtle bg-bg-canvas flex h-14 shrink-0 items-center gap-2 border-b px-3',
  drawerBack:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle inline-flex h-10 w-10 items-center justify-center rounded-md transition-colors duration-fast ease-token',
  drawerTitle: 'text-fg-primary min-w-0 flex-1 truncate text-base font-semibold',
  drawerClose:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle ml-auto inline-flex h-10 w-10 items-center justify-center rounded-md transition-colors duration-fast ease-token',

  drawerPromoShelf: 'border-border-subtle bg-bg-canvas shrink-0 border-b py-2',
  drawerPromoTrack:
    'scrollbar-none flex cursor-grab select-none snap-x snap-mandatory scroll-px-3 gap-3 overflow-x-auto overscroll-x-contain px-3 active:cursor-grabbing ' +
    'scroll-smooth motion-reduce:scroll-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent',

  drawerBody: 'flex-1 overflow-y-auto bg-bg-canvas px-2 py-3',
  drawerListItem:
    'flex items-center gap-3 rounded-lg px-3 py-3 text-left text-fg-primary hover:bg-bg-subtle active:bg-bg-subtle/80 transition-colors duration-fast ease-token w-full',
  drawerThumb:
    'bg-bg-subtle border-border-subtle text-fg-secondary flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-md border',
  drawerLabel: 'min-w-0 flex-1 text-sm font-medium truncate',
  drawerMeta: 'text-fg-muted shrink-0 text-[11px] tabular-nums',
  drawerChevron: 'text-fg-muted h-4 w-4 shrink-0',
  drawerCta:
    'border-border-subtle bg-bg-canvas flex shrink-0 items-center justify-between gap-3 border-t px-3 py-3',
  drawerCtaLink:
    'inline-flex flex-1 items-center justify-center gap-1.5 rounded-full bg-accent text-accent-fg px-4 py-2.5 text-sm font-semibold',
} as const;
